const apiBase: string = '/api';
const planiteamBase: string = '/fp';

export const API = {
  SIGN_IN: '/api/common/auth/sign-in',
  CLIENT: '/api/common/clients/',
  SITES: '/api/common/sites/by_clients/',
  USERS: '/api/common/users/',
  SECTORBYSITE: '/api/common/sectors/by_sites/',

  GET_USERS_BY_ABILITIES_SKILLS_USERS: '/api/common/users/by_abilities_and_skills',


  TASK: apiBase + planiteamBase + '/task',
  TASK_BY_PLANNING: apiBase + planiteamBase + '/task/by_planning',
  TASK_FULL_BY_PLANNING_AND_DATE: apiBase + planiteamBase + '/task/full/by_planning_and_date',
  TASK_BY_USER: apiBase + planiteamBase + '/task/by_user',
  TASK_FULL: apiBase + planiteamBase + '/task/full',
  TASK_EQUIPMENTS: apiBase + planiteamBase + '/task/equipments',
  TASK_BY_RECURRENCE: apiBase + planiteamBase + '/task/by_recurrence',
  DUPLICATE_TASK: apiBase + planiteamBase + '/task/duplicate',

  TASK_ACTION: apiBase + planiteamBase + '/task_action',
  TASK_ACTION_BY_SECTOR: apiBase + planiteamBase + '/task_action/by_sector',

  LOCATION: apiBase + planiteamBase + '/location',
  LOCATION_BY_SECTOR: apiBase + planiteamBase + '/location/by_sector',

  PLANNING: apiBase + planiteamBase + '/planning',
  PLANNING_BY_SECTOR: apiBase + planiteamBase + '/planning/by_sector',

  ROLE_TASK: apiBase + planiteamBase + '/role_task',
  ROLE_TASK_FULL: apiBase + planiteamBase + '/role_task/full',
  ROLE_TASK_BY_TASK: apiBase + planiteamBase + '/role_task/by_task',
  ROLE_TASK_BY_TASK_FULL: apiBase + planiteamBase + '/role_task/by_task/full',
  ROLE_TASK_BY_TASKS_FULL: apiBase + planiteamBase + '/role_task/by_tasks/full/',

  RTS: apiBase + planiteamBase + '/role_task_skill',
  RTA: apiBase + planiteamBase + '/role_task_ability',
  RTU: apiBase + planiteamBase + '/role_task_user',

  ACTION: apiBase + planiteamBase + '/action',
  ACTION_BY_TASK: apiBase + planiteamBase + '/action/by_task',
  ACTION_FULL: apiBase + planiteamBase + '/action/full',
  ACTION_FULL_BY_TASK: apiBase + planiteamBase + '/action/full/by_task',
  ACTION_VALIDATE: apiBase + planiteamBase + '/action/validate',
  ACTION_VALIDATE_BY_TASK: apiBase + planiteamBase + '/action/validate/by_task',

  NOTE: apiBase + planiteamBase + '/note',
  NOTE_FULL_BY_ACTION: apiBase + planiteamBase + '/note/by_action',

  IMAGE: apiBase + planiteamBase + '/image',
  IMAGE_BY_TASK: apiBase + planiteamBase + '/image/by_task',
  IMAGE_BY_ACTION: apiBase + planiteamBase + '/image/by_action',

  ACTION_ANOMALY: apiBase + planiteamBase + '/action_anomaly',
  ACTION_ANOMALY_BY_SECTOR: apiBase + planiteamBase + '/action_anomaly/by_sector',

  CHART: apiBase + planiteamBase + '/chart',
  CHART_BY_DATES_AND_PLANNING_ID: apiBase + planiteamBase + '/chart/by_planning_and_date',
  EXTRACTION_BY_DATES_AND_PLANNING_ID: apiBase + planiteamBase + '/chart/extraction/by_planning_and_date',

  SETTING: apiBase + planiteamBase + '/setting',
  SETTING_BY_SECTOR: apiBase + planiteamBase + '/setting/by_sector',

  EQUIPMENTS_BY_TASK: apiBase + planiteamBase + '/task_equipment/by_task',
  TASK_EQUIPMENT_BY_TASKS: apiBase + planiteamBase + '/task_equipment/by_tasks',
  TASK_EQUIPMENT: apiBase + planiteamBase + '/task_equipment',

  RECURRENCE: apiBase + planiteamBase + '/recurrence',
  RECURRENCE_BY_TASK: apiBase + planiteamBase + '/recurrence/by_task',

  BREAKTIME_BY_TIMEGRID: apiBase + planiteamBase + '/breaktime/by_sector',
  BREAKTIME: apiBase + planiteamBase + '/breaktime',

  TIMEGRID_BY_SECTOR: apiBase + planiteamBase + '/time_grid/by_sector',
  TIMEGRID_FULL_BY_SECTOR: apiBase + planiteamBase + '/time_grid/full/by_sector',
  TIMEGRID_ENABLE_FULL_BY_SECTOR: apiBase + planiteamBase + '/time_grid/enable_full/by_sector',
  TIMEGRID_FULL: apiBase + planiteamBase + '/time_grid/full',
  TIMEGRID: apiBase + planiteamBase + '/time_grid',

  TIMEGRID_BREAKTIMES: apiBase + planiteamBase + '/time_grid/breaktimes',

  TIMEGRID_RECURRENCE_BY_SECTOR: apiBase + planiteamBase + '/time_grid_recurrence/by_sector',
  TIMEGRID_RECURRENCE_BY_SECTOR_AND_DATES: apiBase + planiteamBase + '/time_grid_recurrence/by_sector_and_dates',
  TIMEGRID_RECURRENCE_FULL_BY_TIMEGRID: apiBase + planiteamBase + '/time_grid_recurrence/full/by_time_grid',
  TIMEGRID_RECURRENCE_FULL: apiBase + planiteamBase + '/time_grid_recurrence/full',
  TIMEGRID_RECURRENCE: apiBase + planiteamBase + '/time_grid_recurrence',

  WARNING_BY_PLANNING: apiBase + planiteamBase + '/warning/by_planning'
};
